import { IRestriktionStatusFilter } from "./IRestriktionStatusFilter";

export class RestriktionStatusFilter implements IRestriktionStatusFilter {
    aktiv: boolean;
    inaktiv: boolean;
    na: boolean;
    constructor() {
        this.aktiv = false;
        this.inaktiv = false;
        this.na = false;
    }
}
